import { c as _c } from "react/compiler-runtime";
import { IcoArrowCircleUp16 } from '@onefootprint/icons';
import type { Document } from '@onefootprint/request-types/dashboard';
import { Badge, LinkButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useShowOnboarding from '../../../onboardings-shared/hooks/use-show-onboarding';
import getDocumentStatus from '../../utils/get-document-status';
import DocumentStatusBadge from '../document-status-badge';
type ItemLabelProps = {
  document: Document | Omit<Document, 'uploads'>;
  title: string;
  showOnboardingLink?: boolean;
};
const RotatedIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="rotate-180"><IcoArrowCircleUp16 color="accent" /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ItemLabel = t0 => {
  const $ = _c(32);
  const {
    document,
    title,
    showOnboardingLink: t1
  } = t0;
  const showOnboardingLink = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "fieldset.documents"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const {
    scrollOnboardingIntoView
  } = useShowOnboarding();
  let t3;
  if ($[1] !== document.startedAt) {
    t3 = format(new Date(document.startedAt ?? ""), "MM/dd/yy h:mm a");
    $[1] = document.startedAt;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const timestamp = t3;
  let t4;
  if ($[3] !== document) {
    t4 = getDocumentStatus(document);
    $[3] = document;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const status = t4;
  let t5;
  if ($[5] !== timestamp) {
    t5 = <span className="flex items-center flex-shrink-0 text-snippet-2 text-quaternary whitespace-nowrap">{timestamp}</span>;
    $[5] = timestamp;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="flex items-center text-quaternary">⋅</span>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== document.kind) {
    t7 = cx("truncate ", {
      "text-snippet-1": document.kind === "custom"
    }, {
      "text-body-2": document.kind !== "custom"
    });
    $[8] = document.kind;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7 || $[11] !== title) {
    t8 = <p className={t7}>{title}</p>;
    $[10] = t7;
    $[11] = title;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== document || $[14] !== status) {
    t9 = status && <><span className="flex items-center text-quaternary">⋅</span><DocumentStatusBadge document={document} status={status} /></>;
    $[13] = document;
    $[14] = status;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== document.redactedAt || $[17] !== t) {
    t10 = document.redactedAt && <><span className="flex items-center text-quaternary">⋅</span><Badge variant="neutral">{t(_temp)}</Badge></>;
    $[16] = document.redactedAt;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== document.onboardingId || $[20] !== scrollOnboardingIntoView || $[21] !== showOnboardingLink || $[22] !== t) {
    t11 = showOnboardingLink && document.onboardingId && <><span className="flex items-center text-quaternary">⋅</span><LinkButton variant="label-2" onClick={() => scrollOnboardingIntoView(document.onboardingId || "", "documents")} iconComponent={RotatedIcon} iconPosition="right">{t(_temp2)}</LinkButton></>;
    $[19] = document.onboardingId;
    $[20] = scrollOnboardingIntoView;
    $[21] = showOnboardingLink;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <div className="flex items-center gap-1 transition-opacity duration-200 md:opacity-0 md:pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto">{t11}</div>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t5 || $[29] !== t8 || $[30] !== t9) {
    t13 = <div className="flex flex-wrap items-center w-full gap-1.5 pr-1">{t5}{t6}{t8}{t9}{t10}{t12}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
export default ItemLabel;
function _temp($) {
  return $.imagesRedacted;
}
function _temp2($_0) {
  return $_0.viewOnboarding;
}